import React from 'react'
import { useEffect, useRef, useState } from 'react'

import { useIsPhone } from '../nav/hooks'

interface AnimateBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  tagName?: string
  animateDelay?: number
  animateTimingFunction?: string
  animateFunction?: string
}

export const AnimateBox = ({
  children,
  className,
  style,
  tagName = 'div',
  animateDelay = 0,
  animateTimingFunction = 'ease-in-out',
  animateFunction = 'fadeInUp',
  ...rest
}: AnimateBoxProps) => {
  const [isMoveIn, setIsMoveIn] = useState(false)
  const boxEl = useRef<HTMLDivElement>(null)
  const isPhone = useIsPhone()
  useEffect(() => {
    if (isPhone) {
      setIsMoveIn(true)
      return
    }
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsMoveIn(true)
          } else {
            // setIsMoveIn(false)
          }
        })
      },
      {
        threshold: [0.1]
      }
    )
    if (boxEl.current) {
      observer.observe(boxEl.current)
    }
  }, [isPhone])
  const classNames = [className, 'animate-box']
  if (isMoveIn) {
    classNames.push(`animate__animated animate__${animateFunction}`)
  } else {
    classNames.push('animate-add-hide')
  }
  const styles = {
    ...style,
    animationDelay: `${animateDelay}s`,
    animationTimingFunction: `${animateTimingFunction}`
  }

  const props = {
    ...rest,
    className: classNames.join(' '),
    ref: boxEl,
    style: styles
  }
  return React.createElement(tagName, props, children)
}
